import Vue from 'vue';
import moment from 'moment-timezone';
import MinMaxInput from '~/components/input/components/min_max_input';
import FormGroup from '../components/form_group';
import Timepicker from '../components/timepicker';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import { DatePicker } from 'element-ui-2';
import {
    Select,
    Option,
    Checkbox,
    CheckboxGroup
} from 'element-ui';

locale.use(lang);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

export default {
    components: {
        MinMaxInput,
        FormGroup,
        Timepicker
    },

    methods: {
        commitVuexForm(key, value, commitFunction) {
            if (typeof commitFunction === 'function') {
                commitFunction({
                    [key]: value
                });
                this.$emit('formChange');
            }
        },

        onDatePick(key, value, commitFunction, format = 'YYYY-MM-DD') {
            const formattedValue = this.formatDateArray(value);
            this.commitVuexForm(key, formattedValue, commitFunction);
        },

        formatDateArray(value, format = 'YYYY-MM-DD') {
            value = value === undefined ? null : value;

            if (value && Array.isArray(value) && value[0] && value[1]) {
                value[0] = new Date(value[0]).toISOString();
                value[1] = new Date(value[1]).toISOString();
            }

            return value;
        },

        onSelect(key, value, commitFunction) {
            this.commitVuexForm(key, value, commitFunction);
        },

        onInput(key, value, commitFunction) {
            this.commitVuexForm(key, value, commitFunction);
        },

        onCheck(key, event, commitFunction) {
            const isChecked = event.target.checked;
            this.commitVuexForm(key, isChecked, commitFunction);
        }
    }
}
